import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://nynuoequvqkgpsonynkm.supabase.co";
const SUPABASE_KEY = "sb_publishable_S-0URbwNODdRCStD1NAGRw_VOtYO7-g";

export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);
